import React from 'react';
import { Grid, Segment, Icon, Input } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import VM from './VM';

const VendingMachines = ({ loading, vmData, onSearchChnage , onIdSearchChange }) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  return (
    <Grid centered padded style={{ paddingTop: '8vh' }}>
      <Helmet>
        <title>  Vending Machines Listing </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Vending Machines Listing
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={5} textAlign="center">
          <Input
            fluid
            icon
            placeholder="Search using VM name..."
            label="Search Name"
            onChange={onSearchChnage}
          />
        </Grid.Column>
        <Grid.Column width={4} textAlign="center">
          <Input
            fluid
            icon
            placeholder="Search using Id..."
            label="Search ID"
            onChange={onIdSearchChange}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        {vmData &&
          vmData.length &&
          vmData.map(el => (
            <VM
              key={el.id}
              vmId={el.id}
              name={el.name}
              city={el.city}
              state={el.state}
              street={el.street}
              image_id={el.image_id}
            />
          ))}
        {' '}
      </Grid.Row>
    </Grid>
  );
};

export default VendingMachines;



// WEBPACK FOOTER //
// ./src/Modules/Sales&Inventory/component.jsx